import type { DashboardPayload } from '@/types/dashboard'

export function KpiBoard({ data, loading }: { data: DashboardPayload | null; loading: boolean }) {
  if (loading && !data) {
    return (
      <div className="kpi-board" aria-busy="true">
        {Array.from({ length: 6 }).map((_, i) => (
          <div className={`kpi skeleton${i === 0 ? ' accent' : ''}`} key={i}>
            <div className="v">—</div>
            <div className="l">Loading</div>
          </div>
        ))}
      </div>
    )
  }

  const m = data?.metrics
  const out = data?.health.outbox
  const cells: [string | number, string, boolean][] = [
    [m?.totalActivities ?? '—', 'Activities', true],
    [m?.totalWorkflows ?? '—', 'Workflows', false],
    [m?.drafts ?? 0, 'Drafts', false],
    [m?.acceptanceRate != null ? `${m.acceptanceRate}%` : '—', 'Accept %', false],
    [m?.timeSavedHuman || '—', 'Est. time saved', true],
    [`${out?.pending ?? 0}p / ${out?.dead ?? 0}d`, 'Outbox', false]
  ]

  return (
    <div className="kpi-board" aria-live="polite">
      {cells.map(([v, l, accent]) => (
        <div className={`kpi${accent ? ' accent' : ''}`} key={l}>
          <div className="v">{v}</div>
          <div className="l">{l}</div>
        </div>
      ))}
    </div>
  )
}
